export default class Stat {
  constructor(data) {
    if(!data) {
      data = {};
    }
    this._id = data._id;
    this.name = data.name;
    this.value = data.value;
    this.lastUpdate = data.lastUpdate;
  }
}
